import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ToastClientService } from "../../../services/toast/toast-client.service";

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {
  addOrEditRole: string;
  roles = [];
  title = 'modal2';
  formGroup;
  deletePopupUiData;

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toast: ToastClientService
    // public toastService: ToastService
  ) {}

  ngOnInit() {
    this.getAllRoles();
  }

  getAllRoles() {
    this.apiService.getHeaders(this.apiConfig.configGetRoles)
      .subscribe((res: any) => {
        this.roles = res.body.data
        console.log(this.roles);
      }, err => {
        console.log(err);
      })
  }

  addRole(targetModal) {
    this.addOrEditRole = 'add'

    this.formGroup = this.fb.group({
      role_name: new FormControl('', [Validators.required]),
      role_full_name: new FormControl('', [Validators.required]),
    });

    this.showRoleModal(targetModal);
  }

  get f (){
    return this.formGroup.controls
  }

  editRole(targetModal, roleInfo){
    this.addOrEditRole = 'edit'
    this.formGroup = this.fb.group({
      id: roleInfo.id,
      role_name: new FormControl(roleInfo.role_name, [Validators.required]),
      role_full_name: new FormControl(roleInfo.role_full_name, [Validators.required]),
      status: 1
    });

    this.showRoleModal(targetModal);
  }

  deleteRole(targetModal, roleInfo){
    this.addOrEditRole = 'delete'
    this.deletePopupUiData = roleInfo.role_name;

    this.formGroup = this.fb.group({
      id: roleInfo.id,
      status: 0
    });

    this.showRoleModal(targetModal);
  }

  showRoleModal(targetModal){
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
  }

  
  submitted = false;
  onSubmitRoles(formData) {
    this.submitted = true;

    if (this.formGroup.invalid) {
      return
    }

    let apiUrl;    
    if(this.addOrEditRole == 'add'){
      apiUrl = this.apiConfig.configAddRoles

      this.apiService.post(apiUrl, formData)
      .subscribe((res:any)=>{
        this.toast.Success(res.data.message);
        console.log(res);
        this.RoleActionSuccess(formData);
      },err=>{
        console.log('err', err);
      })      

    } else if(this.addOrEditRole == 'edit'){
      apiUrl = this.apiConfig.configUpdateRoles + '?id=' + formData.id;
      
    } else if(this.addOrEditRole == 'delete'){
      apiUrl = this.apiConfig.configUpdateRoles + '?id=' + formData.id;
      
    }

    console.log('API:', apiUrl, 'FD:', formData);
    //update and delete will only work with PUT
    //make status 0 for delete
    this.apiService.put(apiUrl, formData)
    .subscribe((res:any)=>{
      this.toast.Success(res.data.message);
      console.log(res);
      this.RoleActionSuccess(formData);
    },err=>{
      console.log('err', err);
    })

  }

  RoleActionSuccess(data){
    this.modalService.dismissAll();
    this.getAllRoles();
  }
}

